export const TOP_MENU_BUTTON_CLASS_NAME = "w-[50px] max-w-[50px] min-h-10 rounded-8 sm:rounded-8";

export const TOP_MENU_BUTTON_OPEN_CLASS_NAME =
  "bg-blue-100 hover:bg-blue-100 group-data-[focus]:bg-blue-100 dark:bg-blue-900 dark:hover:bg-blue-900 dark:group-data-[focus]:bg-blue-900";
